import styled, { css, keyframes } from 'styled-components'
import { colors } from '../../styles/constants'

// Estilos
const listText = css`
  background: none;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  padding: 0;
  text-align: end;
`
const lineBreak = css`
  margin: 0 16px;
  border-top: 1px solid ${colors.gray.default};
  padding-top: 16px;
`
const textHighlight = {
  color: colors.cyan.default,
  backgroundColor: colors.cyan.light,
  fontWeight: 600
}

const strongText = css`
  color: ${textHighlight.color};
  font-weight: ${textHighlight.fontWeight};
`
/* Animações */
const growVertical = keyframes`
  from { transform: scaleY(0); }
  to { transform: scaleY(1); }
`

const growHorizontal = keyframes`
from { transform: scaleX(0); }
to { transform: scaleX(1); }
`
/* Componentes */
export const Container = styled.section`
  border: 1px solid ${colors.gray.default};
  border-radius: 12px;
  padding: 16px;
  margin: 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  button {
    margin-top: 16px;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`

export const Title = styled.h2`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.96px;
  margin-bottom: 8px;
  strong {
    ${strongText}
  }
`

export const Description = styled.h3`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  text-align: center;
  color: ${colors.gray.dark};
  margin-bottom: 16px;
  strong {
    ${strongText}
    font-family: 'Open Sans';
  }
`

export const BarChartWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 24px;
  ${({ breakLine }) => breakLine && lineBreak}

  ${({ type }) => type === 'list' && css`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin: 0 auto;
  `}
`

export const Bar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  min-height: 128px;
  position: relative;

  &:before {
    content: '';
    display: flex;
    width: ${({ customWidth }) => customWidth || '50px'};
    height: ${({ value, maxData }) => `${(value / maxData) * 105}px`};
    background-color: ${({ value, maxData }) =>
      value === maxData ? colors.cyan.default : colors.gray.default};
    border-radius: 4px;
    margin-bottom: 16px;
    margin-top: 4px;
    order: 2;
    transform-origin: 0 100%;
    animation: ${growVertical} 0.5s cubic-bezier(0.46, 0.03, 0.52, 0.96) forwards;
  }

  ${({ type }) => type === 'list' && css`
    flex-direction: row-reverse;
    min-height: 0;
    width: 100%;

    &:before {
      background-color: ${({ value, maxData, color }) => color ||
      (value === maxData ? colors.cyan.default : colors.gray.default)};
      width: ${({ value, maxData, rankBy }) => rankBy === 'order'
      ? `calc(calc(100% - 168px)/${value})`
      : `calc(${value / maxData} * calc(100% - 168px))`};
      height: ${({ customHeight }) => customHeight || '8px'};
      margin: 0 8px 0 16px;
      ${({ value }) => value === 0 && 'margin-right: 0'};
      transform-origin: 0 100%;
      animation: ${growHorizontal} 0.5s cubic-bezier(0.65, 0.05, 0.36, 1) forwards;
    }
  `}
`

export const Qtd = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: ${({ value, maxData }) => value === maxData ? '600' : '400'};
  font-size: 13px;
  line-height: 19px;
  color: ${colors.gray.dark};
  order: 1;
  ${({ value, maxData, maxColor }) => (value === maxData && maxColor) && css`
    color: ${textHighlight.color};
    font-weight: ${textHighlight.fontWeight};
  `}
  ${({ type }) => type === 'list' && css`
  ${listText}
  color: ${colors.darkerGray};
  `}
`

export const Label = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 4px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 19px;
  padding: 2px 8px 3px;
  border-radius: 8px;
  color: ${colors.gray.dark};
  background-color: ${colors.gray.lighter};
  order: 3;

  ${({ type, value, maxData, maxColor }) => (value === maxData && maxColor) && css`
    color: ${textHighlight.color};
    font-weight: ${textHighlight.fontWeight};
    ${type !== 'list' && `background-color: ${textHighlight.backgroundColor}`};
  `}

  ${({ type, labelWidth }) => type === 'list' && css`
    flex: 0 0 auto;
    width: ${labelWidth ? `${labelWidth}px` : '38%'};
    text-align: end;
    ${listText}
  `}
`

export const CardSkeleton = styled.div`
  margin-bottom: 16px;
`
